<template>
    <div class="profile-card-button">
        <el-button
            type="primary"
            :id="searchButtonId"
            @click="isModalVisible = true"
        >
            <span class="standard">
                {{ $trans('web_search.profile_card.request_dossier') }}
                <el-icon class="el-icon--right">
                    <img
                        src="/media/images/web_search/request_dossier.svg"
                        alt="Request Dossier Icon"
                        class="request-dossier-icon"
                    />
                </el-icon>
            </span>
        </el-button>

        <RequestDossierModal v-model="isModalVisible" :profile="profile" />
    </div>
</template>

<script>
import RequestDossierModal from "../CheckoutProcess/RequestDossierModal.vue";

export default {
    components: {
        RequestDossierModal,
    },
    props: {
        profile: {
            type: Object,
            required: true,
        },
        groupName: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isModalVisible: false,
        };
    },
    computed: {
        searchButtonId() {
            switch (this.groupName) {
                case "Deutsche Interim AG":
                    return "di_request_dossier";
                case "Swiss Interim GmbH":
                    return "si_request_dossier";
                case "Matchmaker":
                    return "mm_request_candidateboard";
                default:
                    return "mm_request_dossier";
            }
        },
    },
};
</script>

<style scoped>
.el-button--primary {
    --el-button-text-color: var(--el-color-white);
    --el-button-bg-color: #41abc4;
    --el-button-border-color: #41abc4;
    --el-button-outline-color: var(--el-color-primary-light-5);
    --el-button-active-color: var(--el-color-primary-dark-2);
    --el-button-hover-text-color: var(--el-color-white);
    --el-button-hover-link-text-color: var(--el-color-primary-light-5);
    --el-button-hover-bg-color: #2699b2;
    --el-button-hover-border-color: #2699b2;
    --el-button-active-bg-color: var(--el-color-primary-dark-2);
    --el-button-active-border-color: var(--el-color-primary-dark-2);
    --el-button-disabled-text-color: var(--el-color-white);
    --el-button-disabled-bg-color: var(--el-color-primary-light-5);
    --el-button-disabled-border-color: var(--el-color-primary-light-5);
}

.profile-card-button .el-button {
    width: 100%;
    position: relative;
    justify-content: left;
    cursor: pointer;
    height: 38px;
    border-radius: 5px;
}

.el-icon--right {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 24px;
    width: 24px;
}

.el-icon svg {
    height: 100%;
    width: 100%;
}

.request-dossier-icon {
    filter: brightness(0%) hue-rotate(360deg) saturate(1000%) contrast(1000%)
        invert(100%);
    scale: 1.3;
    margin-top: -3px;
}
</style>
